import React, { Fragment } from "react"
import { Box } from "@shared-components/Box/Box"
import { Link } from "@shared-components/Link/Link"
import { Heading } from "@shared-components/Heading/Heading"
import {
  columnItemContainerStyles,
  columnItemContentStyles,
  descriptionStyles,
  headingStyles,
  iconsColumnContainerStyles,
  iconsColumnWrapStyles,
  imageStyles,
  imageWrapStyles,
  ratioStyles,
} from "./styles"
import {
  Icon as SharedIconItem,
  IconModule,
} from "../../carlsberg-headless/types/modules/Icon"
import { Container } from "@shared-components/Container/Container"
import { UmbracoImage } from "@shared-components/Image/UmbracoImage/UmbracoImage"
import { generateCbKey } from "../../shared/utils/generate-cbKey"
import { FlexCell, FlexRow } from "@shared-components/FlexGrid/FlexGrid"
import ParseHtmlToReact from "@shared-components/ParseHtmlToReact/ParseHtmlToReact"
import { Text } from "@shared-components/Text/Text"
import { AspectRatio } from "@shared-components/AspectRatio/AspectRatio"

export type IconsProps = IconModule

export type IconItemProps = SharedIconItem

const IconItem: React.FC<IconItemProps> = ({ image, title, description }) => (
  <Fragment>
    <Box sx={imageWrapStyles}>
      {image && (
        <AspectRatio ratio={["1:1"]} sx={ratioStyles}>
          <UmbracoImage
            image={image}
            isCover
            alt={image.altText ?? ""}
            width={[85, 175, 175]}
            height={[85, 175, 175]}
            sx={imageStyles}
          />
        </AspectRatio>
      )}
    </Box>
    <Box sx={columnItemContentStyles}>
      {title && (
        <Heading sx={headingStyles} as="h5">
          {title}
        </Heading>
      )}
      {description &&
        (!description.includes("<p") ? (
          <Text sx={descriptionStyles}>{description}</Text>
        ) : (
          <Box sx={descriptionStyles}>
            <ParseHtmlToReact html={description} />
          </Box>
        ))}
    </Box>
  </Fragment>
)

const Icons: React.FC<IconsProps> = ({ icons }) => {
  if (!icons) return null

  return (
    <Container sx={iconsColumnWrapStyles} key={generateCbKey()}>
      <FlexRow spacing={[2, 2, 4]} sx={iconsColumnContainerStyles}>
        {icons.map((icon: IconItemProps, index: number) => (
          <FlexCell col={[12, 6, 3]} key={`${index}`}>
            {icon.link ? (
              <Link
                sx={columnItemContainerStyles}
                to={icon.link.url}
                target={icon.link.target ?? ""}
              >
                <IconItem {...icon} />
              </Link>
            ) : (
              <Box sx={columnItemContainerStyles}>
                <IconItem {...icon} />
              </Box>
            )}
          </FlexCell>
        ))}
      </FlexRow>
    </Container>
  )
}

export { Icons }
